import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import ConsolidationForm from "./ConsolidationComponents/ConsolidationForm";

import { useAddConsolidationMutation } from "store/services/consolidationApi";

const ConsolidationCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Consolidations", path: "/app/crm/consolidation/list" },
    { title: "New Consolidation" }
  ];

  const [createConsolidation, { isLoading: creatingConsolidation }] = useAddConsolidationMutation();

  const handleAddConsolidation = async (data) => {
    try {
      const { _id } = await createConsolidation(data).unwrap();
      toast.success("Consolidation Created!");
      navigate(`/app/crm/consolidation/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Consolidation!"
      );
    }
  };

  useAppMeta("New Consolidation");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingConsolidation}>
      <BreadcrumbLayout.Paper>
        <ConsolidationForm isBusy={creatingConsolidation} onSubmit={handleAddConsolidation} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ConsolidationCreateScreen;
